export default "__VITE_ASSET__b83f2711__"